<div
	class="wrapper"
	[ngStyle]="{
		width: size + 'px',
		height: size + 'px',
	}"
>
	@if (avatarIsAvailable) {
		<img
			#memberAvatar
			class="ph-no-capture"
			[src]="avatarUrl"
			(error)="memberAvatar.src = './assets/icons/user.svg'"
			alt="{{ data?.firstName || data?.lastName || data?.name || fullName }}'s  avatar"
			[ngStyle]="{
				width: size + 'px',
				height: size + 'px',
			}"
		/>
	} @else {
		@if (imagePlaceHolder) {
			<div
				class="placeholder"
				[ngStyle]="{
					width: size + 'px',
					height: size + 'px',
					'font-size': getPlaceholderFontSize(size),
				}"
			>
				<mat-icon [svgIcon]="imagePlaceHolder"></mat-icon>
			</div>
		} @else {
			<div
				class="text-placeholder ph-no-capture"
				[ngStyle]="{
					width: size + 'px',
					height: size + 'px',
					'font-size': getPlaceholderFontSize(size),
					'background-color': backgroundColor,
				}"
			>
				<span>{{
					data ? (data | auUserInitialsPipe) : (fullName | auUserInitialsPipe)
				}}</span>
			</div>
		}
	}
</div>
